function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
import Svg from './Svg';
import styled from 'styled-components';
const BaseComponent = ({
  size = 24,
  title,
  desc,
  titleId,
  descId,
  tabIndex = -1,
  focusable = false,
  role = 'img',
  'aria-hidden': ariaHidden = true,
  ...props
}) => {
  let ariaLabelledBy = titleId ? titleId : '';
  ariaLabelledBy += desc && descId ? ` ${descId}` : '';
  ariaLabelledBy = ariaLabelledBy ? ariaLabelledBy : undefined;
  props['aria-labelledby'] = ariaLabelledBy;
  return /*#__PURE__*/React.createElement(Svg, _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: size,
    width: size,
    title: title,
    titleId: titleId,
    desc: desc,
    descId: descId,
    "aria-labelledby": ariaLabelledBy,
    "aria-hidden": ariaHidden,
    fill: "currentcolor",
    role: role,
    tabIndex: tabIndex,
    focusable: focusable
  }, props), !!title && /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title), !!desc && /*#__PURE__*/React.createElement("desc", {
    id: descId
  }, desc), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M20.01 2C21.108 2 22 2.898 22 3.99v16.02c0 1.099-.898 1.99-1.99 1.99H3.99C2.892 22 2 21.102 2 20.01V3.99C2 2.892 2.898 2 3.99 2h16.02zm-7.196 3.848c-1 0-1.81.358-2.258.79-.085.086-.172.189-.258.292v-.844h-2.36v12.07h2.669v-3.7c.707.43 1.225.757 2.223.757 3.086 0 3.897-2.86 3.897-4.701 0-2.996-1.708-4.664-3.913-4.664zM12.4 7.72l.121.006c.08.008.16.024.241.046 1.087.277 1.413 1.533 1.413 2.72 0 1.412-.57 2.807-1.86 2.807-.431 0-.88-.19-1.19-.516-.343-.378-.637-1.085-.637-2.221 0-.843.17-1.62.551-2.118.38-.516.879-.723 1.362-.723L12.4 7.72z"
  }));
};
const SvgPriceline = styled(BaseComponent).withConfig({
  displayName: "Priceline__SvgPriceline",
  componentId: "sc-17dd25j-0"
})(["outline:none;"]);
SvgPriceline.isIcon = true;
export default SvgPriceline;